<button type="button"
        class="button button_no-margin"
        (click)="login()"
>
  <span>{{ label }}</span>
  <svg link-external-icon size="small"></svg>
</button>
